export enum OrganizationType {
  OrganizationCity = 'OrganizationCity',
  OrganizationCountry = 'OrganizationCountry',
  OrganizationCounty = 'OrganizationCounty',
  OrganizationDepartment = 'OrganizationDepartment',
  OrganizationPoli = 'OrganizationPoli',
  OrganizationState = 'OrganizationState',
  OrganizationNGO = 'OrganizationNGO',
}

export enum PaymentMethod {
  BankPayment = 'BankPayment',
  CardPayment = 'CardPayment',
  CashPayment = 'CashPayment',
  CheckPayment = 'CheckPayment',
  MoneyOrderPayment = 'MoneyOrderPayment',
  OtherPayment = 'OtherPayment',
}

/**
 * @deprecated in favor of CaseStatus / CaseStatusEnum
 */
export enum Status {
  Unsubmitted = 'Unsubmitted',
  Open = 'Open',
  Closed = 'Closed',
  Deleted = 'Deleted',
  Hidden = 'Hidden',
}
